import i18n from '../../../../../locales/index'
import siderTrigger from './sider-trigger.vue'
export default siderTrigger
